import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

import thousandSeparator from '../../../utils/thousandSeparator';

export default function CustomerTable({ order }) {
  const { user } = useSelector((s) => s.account);
  return (
<Card>
  <CardContent>
    <Box style={{ overflowX: 'auto' }}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant='h4'>
            Sucursal:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
            {order.store.name}
            </Typography>
            <>
              {order.store.address ? (
                <Typography variant='h4'>
                  {order.store.address}
                </Typography>
              ) : null}
            </>
            <>
              {order.store.city ? (
                <Typography variant='h4'>
                  {order.store.city}
                </Typography>
              ) : null}
            </>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
            Vendedor/a:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
            {order.user ? `${order.user.name} ${order.user.lastname}` : ''}
            </Typography>
          </TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography variant='h4'>
              Numero Pedido:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              {order.orderNumber}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              Folio:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              {order.billing && order.billing.folio ? order.billing.folio : ''}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              Totales:
            </Typography>
          </TableCell>
          <TableCell>
            {order.billing && order.billing.net ? (
              <Typography variant='h4'>
                {`Monto Neto: $${thousandSeparator(order.billing.net, '.')}`}
              </Typography>
            ) : null}
            {order.billing && order.billing.exempt && order.billing.exempt > 0 ? (
              <Typography variant='h4'>
                {`Monto Exento: $${thousandSeparator(order.billing.exempt, '.')}`}
              </Typography>
            ) : null}
            {order.billing && order.billing.tax ? (
              <Typography variant='h4'>
                {`IVA: $${thousandSeparator(order.billing.tax, '.')}`}
              </Typography>
            ) : null}
            {order.subtotal ? (
              <Typography variant='h4'>
                  {`Subtotal: $${thousandSeparator(order.subtotal, '.')}`}
                </Typography>
            ) : null}
            {order.tip ? (
              <Typography variant='h4'>
                  {`Propina: $${thousandSeparator(order.tip, '.')}`}
                </Typography>
            ) : null}
            {user.client.customProductBillable ? (
              <>
                {order.billing && order.billing.total ? (
                  <Typography variant='h4'>
                    {`Total Boleta: $${thousandSeparator(order.billing.total, '.')}`}
                  </Typography>
                ) : null}
                {order.billing && order.billing.paymentAmount ? (
                  <Typography variant='h4'>
                    {`Total Pagado: $${thousandSeparator(order.billing.paymentAmount, '.')}`}
                  </Typography>
                ) : null}
              </>
            ) : (
              <>
                {order.billing
                  && order.billing.net !== null
                  && order.billing.tax !== null
                  && order.billing.exempt !== null ? (
                    <Typography variant='h4'>
                      {`Total Boleta: $${order.billing.total ? thousandSeparator(order.billing.total, '.') : thousandSeparator(order.billing.net + order.billing.exempt + order.billing.tax, '.')}`}
                    </Typography>
                  ) : null}
                {order.billing
                  && order.billing.paymentAmount
                  && order.billing.total == null
                  && order.billing.net !== null
                  && order.billing.tax !== null
                  && order.billing.exempt !== null ? (
                    <Typography variant='h4'>
                      {`Total ${user.client.customProductName}: $${thousandSeparator(order.billing.paymentAmount - (order.billing.net + order.billing.exempt + order.billing.tax), '.')}`}
                    </Typography>
                  ) : null}
                {order.billing
                  && order.billing.paymentAmount
                  && order.billing.total != null ? (
                    <Typography variant='h4'>
                      {`Total ${user.client.customProductName}: $${thousandSeparator(order.billing.paymentAmount - order.billing.total, '.')}`}
                    </Typography>
                  ) : null}
                {order.billing && order.billing.paymentAmount ? (
                  <Typography variant='h4'>
                    {`Total Pagado: $${thousandSeparator(order.billing.paymentAmount, '.')}`}
                  </Typography>
                ) : null}
               </>
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography variant='h4'>
              Documento:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              {order.billing && order.billing.type ? order.billing.type.toUpperCase() : null}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='h4'>
              Link:
            </Typography>
          </TableCell>
          <TableCell>
            {order.billing && order.billing.urlPdf ? (
              <a href={order.billing.urlPdf} target="_blank" rel="noopener noreferrer">Ver {`${order.billing.type}`}</a>
            ) : null}
          </TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
    </Table>
    </Box>
  </CardContent>
</Card>
  );
}
